(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("2gjUe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a54eb359399f0a10$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $exvWl = parcelRequire("exvWl");
const $a54eb359399f0a10$var$FormCheckbox = ({ label: label, name: name, required: required, disabled: disabled, noPadding: noPadding, halfWidth: halfWidth, checked: checked, justifyStart: justifyStart })=>{
    const { formState: formState, register: register } = (0, $exvWl.useFormContext)();
    const error = formState.errors?.[name];
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: `input-form-container font-ic self-start md:px-2 relative rounded-md checkbox-container border-0 border-none items-center 
       md:pt-2 ${noPadding === true ? "" : "pb-5 md:pb-6"} ${halfWidth === true ? "inline-flex pr-4 md:pl-0 md:pr-4" : "w-full flex"} ${justifyStart === true ? "md:justify-start" : "md:justify-end"}`,
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("label", {
                className: "text-black500 top-0 text-tiny pr-0 mb-0 flex items-center cursor-pointer",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("input", {
                        className: "checkbox",
                        ...register(name, {
                            required: required
                        }),
                        type: "checkbox",
                        readOnly: disabled,
                        defaultChecked: checked
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "checkmark"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "my-0",
                        dangerouslySetInnerHTML: {
                            __html: label
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                className: "m-0 absolute text-red500 text-tiny bottom-1",
                children: error?.type === "required" && "Du m\xe5ste godk\xe4nna integritetspolicyn"
            })
        ]
    });
};
var $a54eb359399f0a10$export$2e2bcd8739ae039 = $a54eb359399f0a10$var$FormCheckbox;

});

})();
//# sourceMappingURL=FormCheckbox.e2dedba8.js.map
